import { useGetFoldersQuery } from 'features/mediaLibrary/mediaApi';
import { useActiveOrganisation } from 'hooks/useActiveOrganisation';
import { useMemo } from 'react';
import { createSelector } from '@reduxjs/toolkit';

const emptyArray = [];

export function useGetFolders(parent = null) {
    const currentOrganisationId = useActiveOrganisation();

    const filterFolders = useMemo(() => {
        // Return a unique selector instance for this page so that
        // the filtered results are correctly memoized
        return createSelector(
            (res) => res.data,
            (_data, parent) => parent,
            (data, parent) => {
                if (data) {
                    return data.filter((folder) => folder.parentFolder === parent && folder.deletedAt === null);
                }

                return emptyArray;
            },
        );
    }, []);

    const { folders } = useGetFoldersQuery(currentOrganisationId, {
        selectFromResult: (result) => ({
            folders: filterFolders(result, parent),
        }),
    });

    return folders;
}
